module.exports = __webpack_public_path__ + "img/visibility-fill.4cd1a57b.svg";